/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { Registre } from '@/types';

type RegistreStoreType = {
  registre: Registre;
  setRegistre: (registre: Registre) => void;
};

const useRegistreStore = create<RegistreStoreType>()(
  devtools((set) => ({
    registre: null,
    setRegistre: (registre) => set({ registre }),
  })),
);

export default useRegistreStore;
